// Configuration utility for API endpoints
// Supports both runtime and build-time configuration

// Extend Window interface to include our config
declare global {
  interface Window {
    REACT_APP_CONFIG?: {
      API_URL: string;
      API_KEY: string;
      ENVIRONMENT: string;
    };
  }
}

interface AppConfig {
  API_URL: string;
  API_KEY: string;
  ENVIRONMENT: string;
}

export const getApiConfig = (): AppConfig => {
  // Use environment variables directly (set at runtime by Docker)
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000';
  const apiKey = process.env.REACT_APP_API_KEY || 'HWL3Ne6Zh-_Cfo1ndcHj00scUsIVlSQP84sDI-y-R0E';
  const environment = process.env.REACT_APP_ENVIRONMENT || 'development';
  
  return {
    API_URL: apiUrl,
    API_KEY: apiKey,
    ENVIRONMENT: environment
  };
};

export const getApiBaseUrl = (): string => {
  const config = getApiConfig();
  const baseUrl = config.API_URL.endsWith('/') ? config.API_URL.slice(0, -1) : config.API_URL;
  
  return baseUrl;
};

export const getApiKey = (): string => {
  const config = getApiConfig();
  return config.API_KEY;
};

export const getChatbotApiUrl = (): string => {
  const chatbotUrl = process.env.REACT_APP_CHATBOT_BACKEND_API_URL || 'http://localhost:8002/api/chat';
  return chatbotUrl;
};

export const getChatbotApiKey = (): string | null => {
  const key = process.env.REACT_APP_CHATBOT_API_KEY;
  return key && key.trim().length > 0 ? key : null;
};